import React from "react";
import {SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class LeftArrowIcon extends React.Component {
    render() {
        return (
            <SvgIcon {...this.props} flipOnRTL>
               <path transform="translate(16 2.5) scale(-1, 1)" fill="currentColor" d="M11.193,8.327h0L3.46.594A2.027,2.027,0,1,0,.593,3.459l6.3,6.3-6.3,6.3A2.027,2.027,0,0,0,3.46,18.928l7.732-7.733h0a2.027,2.027,0,0,0,0-2.867" />
            </SvgIcon>
        );
    }
}
